import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomAppStore({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.81 15.94c-.718 1.011-1.46 2.017-2.631 2.038-1.153.02-1.523-.659-2.839-.659-1.317 0-1.729.638-2.817.68-1.131.04-1.991-1.093-2.714-2.1C3.33 13.84 2.204 10.078 3.72 7.54c.751-1.262 2.097-2.06 3.555-2.08 1.11-.02 2.16.721 2.839.721.679 0 1.952-.89 3.291-.76.56.023 2.133.218 3.144 1.644-.08.05-1.878 1.059-1.856 3.16.022 2.51 2.28 3.344 2.307 3.355-.02.06-.361 1.191-1.19 2.36zm-4.957-13.7c.566-.692 1.523-1.205 2.312-1.24.101.96-.27 1.92-.817 2.613-.549.692-1.447 1.23-2.328 1.158-.12-.939.324-1.918.833-2.532z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
export default SvgIconCustomAppStore;
